import { HubCheckinProvider } from '../../contexts/HubCheckinProvider';
import { LiveCheckinDataContextProvider } from '../live-checkin/useLiveCheckInDataContext';
import LiveCheckinPublicContent from './LiveCheckinPublicContent';

const LiveCheckinPublicPage = () => {
    return (
        <HubCheckinProvider>
            <LiveCheckinDataContextProvider>
                <LiveCheckinPublicContent />
            </LiveCheckinDataContextProvider>
        </HubCheckinProvider >
    );
};

export default LiveCheckinPublicPage;